module.exports = __webpack_public_path__ + "assets/Inter.45cae4a4.woff2";